import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  actions: {
    fetchPricingOverrides() {
      return axiosIns.get('pricing/overrides')
    },
    postPricingOverride(_, payload) {
      return axiosIns.post('pricing/overrides', payload)
    },
    deleteOverride(_, id) {
      return axiosIns.delete(`/pricing/overrides/${id}`)
    },
    getPricingOverride(_, id) {
      return axiosIns.get(`/pricing/overrides/${id}`)
    },
    editPricingOverride(_, { id, data }) {
      return axiosIns.patch(`/pricing/overrides/${id}`, data)
    },
  },

}
